import React from 'react';
import { Image, Text, View } from 'react-native';
import { textPrimary_9_3 } from '../TextComponent/TextStyle';
//= ========================================================================

const BigIconWithTextLine = ({
  globJSON,
  simPlatform,
  icon, txt,
}) => {
  const myStyles = {
    container: {
      marginBottom: 14,
      alignItems: 'center',
      flexDirection: 'row',
    },
    imageStyle: {
      width: 24, height: 24,
    },
  };
  return (
    <View style={myStyles.container}>
      <Image
        fadeDuration={0}
        style={myStyles.imageStyle}
        source={icon}
      />
      <Text style={[textPrimary_9_3(globJSON, simPlatform), { marginLeft: 8 }]}>
        {txt}
      </Text>
    </View>
  );
};
export default BigIconWithTextLine;
